// import { ArkosConfig } from "../types/new-arkos-config";

// export default function defineConfig(config: ArkosConfig) {
//   return config;
// }
